import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChartLine, faPiggyBank, faClock, faRocket, faBolt, faCheckCircle, faShippingFast, faTruck, faBox, faDolly, faBoxes } from '@fortawesome/free-solid-svg-icons';
import '../../styles/logistic/LogisticTestimonialsSection.css';
import { useTranslation } from 'react-i18next';

const LogisticTestimonialsSection: React.FC = () => {
  const { t } = useTranslation();

  return (
    <section className="logistic-testimonials-section" id="testimonios">
      <div className="logistic-container">
        <div className="logistic-section-header">
          <span className="logistic-section-tag">{t('LogisticTestimonialsSection:section_tag')}</span>
          <h2>{t('LogisticTestimonialsSection:title')}</h2>
        </div>

        <div className="logistic-testimonials-grid">
          <div className="logistic-testimonial-card">
            <div className="logistic-stars">★★★★★</div>
            <p className="logistic-testimonial-text">{t('LogisticTestimonialsSection:testimonial1_text')}</p>
            <div className="logistic-testimonial-author">
              <img src="https://i.pravatar.cc/150?img=33" alt={t('LogisticTestimonialsSection:testimonial1_author_name')} />
              <div>
                <h4>{t('LogisticTestimonialsSection:testimonial1_author_name')}</h4>
                <span>{t('LogisticTestimonialsSection:testimonial1_author_title')}</span>
              </div>
            </div>
            <div className="logistic-testimonial-metric">
              <FontAwesomeIcon icon={faChartLine} />
              <span>{t('LogisticTestimonialsSection:testimonial1_metric')}</span>
            </div>
          </div>

          <div className="logistic-testimonial-card">
            <div className="logistic-stars">★★★★★</div>
            <p className="logistic-testimonial-text">{t('LogisticTestimonialsSection:testimonial2_text')}</p>
            <div className="logistic-testimonial-author">
              <img src="https://i.pravatar.cc/150?img=47" alt={t('LogisticTestimonialsSection:testimonial2_author_name')} />
              <div>
                <h4>{t('LogisticTestimonialsSection:testimonial2_author_name')}</h4>
                <span>{t('LogisticTestimonialsSection:testimonial2_author_title')}</span>
              </div>
            </div>
            <div className="logistic-testimonial-metric">
              <FontAwesomeIcon icon={faPiggyBank} />
              <span>{t('LogisticTestimonialsSection:testimonial2_metric')}</span>
            </div>
          </div>

          <div className="logistic-testimonial-card">
            <div className="logistic-stars">★★★★★</div>
            <p className="logistic-testimonial-text">{t('LogisticTestimonialsSection:testimonial3_text')}</p>
            <div className="logistic-testimonial-author">
              <img src="https://i.pravatar.cc/150?img=52" alt={t('LogisticTestimonialsSection:testimonial3_author_name')} />
              <div>
                <h4>{t('LogisticTestimonialsSection:testimonial3_author_name')}</h4>
                <span>{t('LogisticTestimonialsSection:testimonial3_author_title')}</span>
              </div>
            </div>
            <div className="logistic-testimonial-metric">
              <FontAwesomeIcon icon={faClock} />
              <span>{t('LogisticTestimonialsSection:testimonial3_metric')}</span>
            </div>
          </div>

          <div className="logistic-testimonial-card">
            <div className="logistic-stars">★★★★★</div>
            <p className="logistic-testimonial-text">{t('LogisticTestimonialsSection:testimonial4_text')}</p>
            <div className="logistic-testimonial-author">
              <img src="https://i.pravatar.cc/150?img=64" alt={t('LogisticTestimonialsSection:testimonial4_author_name')} />
              <div>
                <h4>{t('LogisticTestimonialsSection:testimonial4_author_name')}</h4>
                <span>{t('LogisticTestimonialsSection:testimonial4_author_title')}</span>
              </div>
            </div>
            <div className="logistic-testimonial-metric">
              <FontAwesomeIcon icon={faRocket} />
              <span>{t('LogisticTestimonialsSection:testimonial4_metric')}</span>
            </div>
          </div>

          <div className="logistic-testimonial-card">
            <div className="logistic-stars">★★★★★</div>
            <p className="logistic-testimonial-text">{t('LogisticTestimonialsSection:testimonial5_text')}</p>
            <div className="logistic-testimonial-author">
              <img src="https://i.pravatar.cc/150?img=68" alt={t('LogisticTestimonialsSection:testimonial5_author_name')} />
              <div>
                <h4>{t('LogisticTestimonialsSection:testimonial5_author_name')}</h4>
                <span>{t('LogisticTestimonialsSection:testimonial5_author_title')}</span>
              </div>
            </div>
            <div className="logistic-testimonial-metric">
              <FontAwesomeIcon icon={faBolt} />
              <span>{t('LogisticTestimonialsSection:testimonial5_metric')}</span>
            </div>
          </div>

          <div className="logistic-testimonial-card">
            <div className="logistic-stars">★★★★★</div>
            <p className="logistic-testimonial-text">{t('LogisticTestimonialsSection:testimonial6_text')}</p>
            <div className="logistic-testimonial-author">
              <img src="https://i.pravatar.cc/150?img=70" alt={t('LogisticTestimonialsSection:testimonial6_author_name')} />
              <div>
                <h4>{t('LogisticTestimonialsSection:testimonial6_author_name')}</h4>
                <span>{t('LogisticTestimonialsSection:testimonial6_author_title')}</span>
              </div>
            </div>
            <div className="logistic-testimonial-metric">
              <FontAwesomeIcon icon={faCheckCircle} />
              <span>{t('LogisticTestimonialsSection:testimonial6_metric')}</span>
            </div>
          </div>
        </div>

        <div className="logistic-trust-section">
          <h3>{t('LogisticTestimonialsSection:trust_section_title')}</h3>
          <div className="logistic-trust-logos">
            <div className="logistic-trust-logo"><FontAwesomeIcon icon={faShippingFast} /> <span>{t('LogisticTestimonialsSection:trust_logo1')}</span></div>
            <div className="logistic-trust-logo"><FontAwesomeIcon icon={faTruck} /> <span>{t('LogisticTestimonialsSection:trust_logo2')}</span></div>
            <div className="logistic-trust-logo"><FontAwesomeIcon icon={faBox} /> <span>{t('LogisticTestimonialsSection:trust_logo3')}</span></div>
            <div className="logistic-trust-logo"><FontAwesomeIcon icon={faDolly} /> <span>{t('LogisticTestimonialsSection:trust_logo4')}</span></div>
            <div className="logistic-trust-logo"><FontAwesomeIcon icon={faBoxes} /> <span>{t('LogisticTestimonialsSection:trust_logo5')}</span></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LogisticTestimonialsSection;